import styled from 'styled-components'

export const BusinessHoursComponent = styled.div`
  margin-top: 10px;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
    margin: 0 15px;
  }

  .btn-appointment {
    margin: 0 0;
    margin-bottom: 20px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      margin-bottom: 30px;
    }
  }

  .general-info-opening {
    margin-bottom: 20px;
  }

  .business-headline-mb {
    margin-bottom: 5px;
  }

  .business-copy {
    margin-bottom: 20px;
  }

  .business-info {
    margin-top: 10px;
  }

  .business-hours {
    margin-bottom: 5px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      margin-bottom: 15px;
    }

    &.has-time-notice {
      margin-bottom: 20px;

      @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
        margin-bottom: 30px;
      }
    }
  }

  .list-checkmark {
    .not-available:before {
      color: red;
      content: '\\';
    }
  }

  .opening-hours-notice-list {
    display: flex;
    flex-direction: column;
    padding-top: 15px;
  }

  .business-info-list {
    margin-bottom: 20px;
    padding-top: 5px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      padding-top: 15px;
      margin-bottom: 30px;
    }
  }

  .aok-info-copy {
    margin-bottom: 20px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
      margin-bottom: 30px;
    }
  }
`
